import { Form, Input, Switch } from 'antd';

import { TextInput } from '@/shared/ui/TextInput/TextInput';

import type { ConnectorField } from '@/entities/connector';
import { buildConnectorFieldRules, getConnectorFieldPlaceholder } from '@/entities/connector/lib/connectorFieldRules';

type ConnectorFieldFormItemProps = {
  field: ConnectorField;
  namePrefix?: string;
  disabled?: boolean;
  className?: string;
  inputClassName?: string;
  placeholder?: string;
};

export const ConnectorFieldFormItem = ({
  field,
  namePrefix = 'config',
  disabled,
  className,
  inputClassName,
  placeholder,
}: ConnectorFieldFormItemProps) => {
  const resolvedPlaceholder = placeholder ?? getConnectorFieldPlaceholder(field);
  const rules = buildConnectorFieldRules(field);

  const formItemProps = {
    name: [namePrefix, field.label],
    label: field.label,
    rules,
    className,
    validateTrigger: field.inputType === 'number' ? 'onChange' : undefined,
  };

  switch (field.inputType) {
    case 'boolean':
      return (
        <Form.Item key={field.label} {...formItemProps} valuePropName="checked">
          <Switch disabled={disabled} />
        </Form.Item>
      );
    case 'number':
      return (
        <Form.Item key={field.label} {...formItemProps}>
          <TextInput
            className={inputClassName}
            type="text"
            inputMode="decimal"
            placeholder={resolvedPlaceholder}
            disabled={disabled}
            style={{ width: '100%' }}
          />
        </Form.Item>
      );
    case 'textarea':
      return (
        <Form.Item key={field.label} {...formItemProps}>
          <Input.TextArea
            className={inputClassName}
            placeholder={resolvedPlaceholder}
            rows={4}
            disabled={disabled}
            autoSize={{ minRows: 4, maxRows: 4 }}
          />
        </Form.Item>
      );
    case 'password':
      return (
        <Form.Item key={field.label} {...formItemProps}>
          <TextInput className={inputClassName} type="password" placeholder={resolvedPlaceholder} disabled={disabled} />
        </Form.Item>
      );
    case 'text':
    default:
      return (
        <Form.Item key={field.label} {...formItemProps}>
          <TextInput className={inputClassName} type="text" placeholder={resolvedPlaceholder} disabled={disabled} />
        </Form.Item>
      );
  }
};
